module.exports = __webpack_public_path__ + "Server-Unknown.AzureCloudService.b9a96059f6ec5d10440bdac70aecd2aa.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.AzureCloudService.png
// module id = 1266
// module chunks = 1